interface EnvironmentConfig {
  aws: {
    region: string;
    cognito: {
      domain: string;
      clientId: string;
    };
  };
  api: {
    quizGenerator: string;
    quizStorage: string;
    bff: string;
    stripe: string;
    avatar: string;
  };
  websocket: {
    proxy: string;
  };
}

const getEnvVar = (key: string, defaultValue: string = ''): string => {
  const value = process.env[key];
  if (!value && !defaultValue) {
    console.warn(`Missing environment variable: ${key}`);
  }
  return value || defaultValue;
};

export const environment: EnvironmentConfig = {
  aws: {
    region: getEnvVar('REACT_APP_AWS_REGION', 'us-east-2'),
    cognito: {
      domain: getEnvVar('REACT_APP_COGNITO_DOMAIN', 'pastewave-prod-pastewave-admin.auth.us-east-2.amazoncognito.com'),
      clientId: getEnvVar('REACT_APP_COGNITO_CLIENT_ID', '3ec502jdhjvfp1fp708dpbiqs2'),
    },
  },
  api: {
    quizGenerator: getEnvVar('REACT_APP_QUIZ_GENERATOR_API', 'https://rrbxmtlnamifnhvqkfr4eq4rim0srmtz.lambda-url.us-east-2.on.aws'),
    quizStorage: getEnvVar('REACT_APP_QUIZ_STORAGE_API', 'https://2cuhfuxm7dk6degbu7ykrzkpyi0hbngd.lambda-url.us-east-2.on.aws'),
    bff: getEnvVar('REACT_APP_BFF_API', 'https://vqr5zzbm4ls3zirheidvf7a6he0gguyr.lambda-url.us-east-2.on.aws'),
    stripe: getEnvVar('REACT_APP_STRIPE_API', 'https://rtnv5s62g5lemnhf437lbagbom0hecqc.lambda-url.us-east-2.on.aws'),
    avatar: getEnvVar('REACT_APP_AVATAR_API', 'https://ifiqy2f2gp3z4pfpjoa5kc74se0mdpnv.lambda-url.us-east-2.on.aws'),
  },
  websocket: {
    proxy: getEnvVar('REACT_APP_WEBSOCKET_PROXY', 'wss://wsproxy.pastewave.fun'),
  },
};

export default environment;